<template>
  <v-container class="white-wrapper" fluid>
    <div class="config-title" style="max-width: 25rem; margin: 0 auto">
      <router-link to="/config" class="back-icon">
        <v-btn icon large>
          <img class="back-svg" src="@/assets/icon/arrow(back).svg" />
        </v-btn>
      </router-link>
      <div class="text-h6 font-weight-bold">{{$t('Notice.title')}}</div>
    </div>
    <div class="panels-container">
      <template v-if="list.length > 0">
        <div class="item-wrapper justify-center">
          <!-- notice-list_important -->

          <router-link  class="notice-list " v-for="item in list" :key="item.cid"  :to="`/config/news/${item.cid}`"  >
            <div class="notice-info">
              <div class="notice-category">[ <span>{{item.title_sub}}</span> ]</div>
              <div class="notice-title">{{item.title}}</div>
              <div class="notice-list_newimg"></div>
            </div>
            <div class="notice-date">{{ $moment(item.created_at).format('YYYY-MM-DD')}}</div>
          </router-link >


      <!-- <router-link href="" class="notice-link1"   
              v-for="item in news"  :key="item.cid"  :to="`/config/news/${item.cid}`">
              [<span>공지</span>] {{ item.title }}
        </router-link > -->

          <!-- <a href="" class="notice-list notice-list_important">
            <div class="notice-info">
              <div class="notice-category">[ <span>공지</span> ]</div>
              <div class="notice-title">제목</div>
              <div class=""></div>
            </div>
            <div class="notice-date">2022.11.14</div>
          </a>

          <a href="" class="notice-list">
            <div class="notice-info">
              <div class="notice-category">[ <span>서비스 런칭</span> ]</div>
              <div class="notice-title">제목</div>
              <div class="notice-list_newimg"></div>
            </div>
            <div class="notice-date">2022.11.24</div>
          </a> -->

          
        </div>
      </template>
      <template v-else>
          <router-link to="/config" class="notice-link1"  >
              <div style="padding-top:20px; text-align: center;"  >{{$t('Notice.listsNone')}} </div>
          </router-link >
      </template>

      <div class="d-flex justify-center align-center" style="min-height: 2rem">
        <v-btn
          v-show="!noMore"
          @click="getMore"
          color="primary"
          class="font-weight-bold"
          text
        >
          {{ $t('point.more') }}
        </v-btn>
      </div>
    </div>
  </v-container>
</template>
158451477893-dg2vpf6ad4o6k5lftif7tahto0jchlah.apps.googleusercontent.com

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
{
  "access_token": "ya29.a0AeTM1iemwEwhajFvl9Ks6M557gn7ny4Qq_K66Y0J5ivK4vRpKP0Jmhs3JZQIE8PICpOOJ_B6tKV2Qu4oWWQilVlBE17HtrZLEC9blmkv0V-mrFscRdOidCdUnTT9-fwEBxq1FjX_sDASgujBBHgKlLObBrI4aCgYKAf0SARASFQHWtWOmIk5QQIHYXTg2CpjpIsRB8Q0163", 
  "scope": "https://mail.google.com/", 
  "token_type": "Bearer", 
  "expires_in": 3599, 
  "refresh_token": "1//04j0p8jOwawP-CgYIARAAGAQSNwF-L9IrbMWxS0lJ419L4pAdo2g1OhYLYfp1pBOqkOIoKOmBZNKIbrF9g4fRZvGwglg8YsRqprM"
}
<script>
export default {
  data() {
    return {
      list: [],
      noMore: false,
      page: 1,
      size: 10
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters.loading
    }
  },
  created() {
   this.$store.commit('loading', true)
   this.callAPI()
  },
  methods: {
    callAPI() {
      const params = {
        page: this.page,
        size: this.size
      }
      this.$store.commit('loading', true)
      this.$store
        .dispatch('w_l_contents', params)
        .then((res) => {
          this.$store.commit('loading', false)
          // console.log("res.status::" , res.result)
          // console.log("res.status::" , res.length , res.data)
          if( res.length >  0 ) {
            this.noMore = true
            this.list = this.list.concat(res)
          }else{
            this.noMore = true
            // this.$store.commit('loading', false)
            // this.$store.dispatch('toast', {
            //   toast: true,
            //   toast_msg:  '공지사항이 없습니다.',
            //   timeout: 2000
            // })            
          }


          // if (res.status === 200 && res.data.result[0].length > 0) {
          //   const arr = res.data.result[0]
          //   // console.log(  arr  )
          //   this.list = this.list.concat(arr)
          //   if (arr.length < this.size) this.noMore = true

            
          // } else if (res.data.result[0].length === 0) {
          //   this.noMore = true
          // } else throw res
        })
        .catch((err) => {
          this.$store.commit('loading', false)
          this.$store.dispatch('toast', {
            toast: true,
            toast_msg: this.$t('errorServer'),
            timeout: 2000
          })
          // console.log(err)
        })
    },
    getMore() {
      this.page = this.page + 1
      this.callAPI()
    }
  }
}
</script>

<style scoped>
/* .panels-container {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
} */
.item-wrapper {
  margin: 0.5rem 0;
  border-top: 1px solid #9F9F9F;
}
.date-wrapper {
  font-size: 0.8rem;
  color: #cbcbcb;
  font-weight: 500;
}
.type-wrapper {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}
.content-wrapper {
  font-size: 0.9rem;
  display: flex;
  justify-content: flex-end;
}
.unpaid-text {
  text-decoration: underline;
  text-underline-offset: 3px;
}
.notice-list {
  width: 100%;
  height: auto;
  padding-left: 20px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 1px solid #9F9F9F;
  word-break:break-all;
}
.notice-list_important {
  background-color: #7A94AD33;
}
.notice-info {
  width: 100%;
}
.notice-info > div {
  font-size: 1.1rem;
}
.notice-category {
  color: #013E79;
  font-weight: bold;
  float: left;
}
.notice-title {
  margin: 0 5px;
  display: inline;
  float: left;
}
.notice-list_newimg {
  display: inline-block;
  margin-top: 4.5px;
  width: 17px;
  height: 17px;
  background: url(../../../src/assets/icon/new.svg) 100% 100% / cover;
}

.notice-date {
  font-size: 0.9rem;
  color: #9A9A9A;
  margin-top: 5px;
}
</style>
